module.exports = __webpack_public_path__ + "tick.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/tick.svg?color1=%23333333&color2=
// module id = 2215
// module chunks = 67